import { v4 as uuid } from 'uuid';
import { fetchCart } from '../store/cart/thunks/fetchCart';
import { StoreRegistry } from '../store';
import {
  type ProductItemId,
  removeItemsGroupFromCart,
  type SetDelayProps,
  setDelayState as setDelayStateAction
} from '../store/cart';

export const updateCart = () => {
  StoreRegistry.instance.store.dispatch(
    fetchCart({ isInBackground: true })
  );
};

export const setDelayState = (
  props: SetDelayProps | SetDelayProps[]
) => {
  StoreRegistry.instance.store.dispatch(
    setDelayStateAction(props)
  );
};

export const removeItemsGroup = (ids: ProductItemId[]) => {
  const traceId = uuid();

  StoreRegistry.instance.store.dispatch(
    removeItemsGroupFromCart({
      traceId,
      ids
    })
  );

  return traceId;
};
